import colors from 'shared/colors';
import { optionColor, propertyType } from 'shared/constants.json';

export const translatePropertyOptionColor = (propertyOption) => {
  switch (propertyOption.color) {
    case optionColor.grey:
      return colors.grey.base;
    case optionColor.brown:
      return colors.brown.base;
    case optionColor.orange:
      return colors.orange.base;
    case optionColor.yellow:
      return colors.yellow.base;
    case optionColor.green:
      return colors.green.base;
    case optionColor.blue:
      return colors.blue.base;
    case optionColor.purple:
      return colors.purple.base;
    case optionColor.pink:
      return colors.pink.base;
    case optionColor.red:
      return colors.red.base;
    default:
      return colors.grey.base;
  }
};

export const getStatusColor = (statusOption) => {
  switch (statusOption.color) {
    case optionColor.grey:
      return colors.grey.base;
    case optionColor.brown:
      return colors.brown.base;
    case optionColor.orange:
      return colors.orange.base;
    case optionColor.yellow:
      return colors.yellow.base;
    case optionColor.green:
      return colors.green.base;
    case optionColor.blue:
      return colors.blue.base;
    case optionColor.purple:
      return colors.purple.base;
    case optionColor.pink:
      return colors.pink.base;
    case optionColor.red:
      return colors.red.base;
    default:
      return colors.grey.base;
  }
};

// Used for automatic status calculation
export const propertyStatusByScore = (possibleStatusProperties, targetScore, defaultValue) => {
  const sorted = possibleStatusProperties.filter((o) => o.score !== null);
  sorted.sort((a, b) => a.score - b.score);
  if (sorted.length === 0) {
    return defaultValue;
  }
  let nearestProperty = sorted[0];
  let minDifference = Number.MAX_SAFE_INTEGER;

  for (let i = 0; i < sorted.length; i++) {
    if (sorted[i].score - targetScore > 0) {
      continue;
    }
    const difference = Math.abs(sorted[i].score - targetScore);
    if (difference < minDifference) {
      minDifference = difference;
      nearestProperty = sorted[i];
    }
  }

  return nearestProperty;
};

export const getStatusProperty = (goal) => goal.properties.find((item) => item.property.type === propertyType.status);

export const getScoreSuggestion = (value, timePassed, minScore, maxScore) => {
  if (timePassed === 0) {
    return 10;
  }

  return Math.max(minScore, Math.min(maxScore, Math.trunc(10 * (value / (timePassed * 100)))));
};
